import { combineReducers } from "redux";
import {
    FETCH_COMMUNICATIONS_SUCCESS,
    COMMUNICATION_SELECTED,
    FETCH_COMMUNICATORS_SUCCESS,
    PERIOD_SELECTED
} from "./monitorActions";
import { RETURN_TO_HOME } from "../complianceActions";
import { RANGES } from "../../common/components/DateRangeSelector";

function communications(state = [], action) {
    switch(action.type) {
        case FETCH_COMMUNICATIONS_SUCCESS:
            return action.payload;
        case RETURN_TO_HOME:
            return [];
        default:
            return state;
    }
}

function communicators(state = [], action) {
    switch(action.type) {
        case FETCH_COMMUNICATORS_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}

function selectedCommunication(state = null, action) {
    switch(action.type) {
        case COMMUNICATION_SELECTED:
            return action.payload;
        case RETURN_TO_HOME:
            return null;
        default:
            return state;
    }
}

const searchResults = combineReducers({
    communications,
    selectedCommunication
});

export default combineReducers({
    communicators,
    searchResults
});


/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/monitor/monitorReducer.js
 **/